<template>
  <div style="background-color: #f2f2f2;">

    <div class="map-track">
      <!-- <div class="flex align-center" style="cursor:pointer;font-size:22px;padding-bottom: 8px;" @click="goBackList">
        <el-icon class="el-icon-back"></el-icon>
        <div style="font-size: 18px;margin-left: 6px;">回到订单列表</div>
      </div> -->
      <div style="text-align: right;margin-bottom: 8px;"><Language></Language></div>
      <div class="infos">
        <div class="code">
          <span>{{ $t('DomesticTransportation.WaybillNo') }}：{{ addressInfo.TaskContainerID }}</span>
        </div>
        <div class="task-infomation">
          <div class="from">
            <div class="color-3">{{ addressInfo.PickCity }}-{{ addressInfo.PickArea }}</div>
            <div class="color-9">{{ addressInfo.PickContact }}</div>
          </div>
          <div class="status">
            <div class="color-6">{{ statusDescLang(TaskContainerStatus) }}</div>
            <img
              v-if="TaskContainerStatus == '已签收'"
              class="arrow"
              src="@/assets/tms/arrow1.png"
            />
            <img v-else class="arrow" src="@/assets/tms/arrow2.png" />
          </div>
          <div class="to">
            <div class="color-3">{{ addressInfo.DropCity }}-{{ addressInfo.DropArea }}</div>
            <div class="color-9">{{ addressInfo.DropContact }}</div>
          </div>
          <div v-if="TaskContainerStatus == '已签收' && listData.length" class="time">
            <div class="color-3">{{ statusDescLang(TaskContainerStatus) }}</div>
            <div class="color-9">{{ listData[0].EventDT }}</div>
          </div>
        </div>
      </div>
      <div class="map" id="container"></div>

      <el-tooltip v-if="receiptDis" effect="dark" :content="$t('DomesticTransportation.Noreceiptreturnedyet')" :disabled="false" placement="right">
        <span>
          <el-button
            size="mini"
            type="primary"
            plain
            style="margin: 16px 0;"
            icon="el-icon-document"
            disabled
            @click="openReceipt"
          >
          {{ $t('DomesticTransportation.ViewReceiptProof') }}
          </el-button>
        </span>
      </el-tooltip>
      <el-button
        v-else
        size="mini"
        type="primary"
        plain
        style="margin: 16px 0;"
        icon="el-icon-document"
        @click="openReceipt"
      >
      {{ $t('DomesticTransportation.ViewReceiptProof') }}
      </el-button>
      <div class="time-line">
        <div v-if="listData && listData.length" class="time-line-list">
          <div
            v-for="(item, index) in listData"
            :key="index"
            class="time-line-item"
          >
            <div
              class="node-status"
              :style="{ color: index === 0 ? '#59B9D3' : '#4B5563' }"
            >
              {{ statusDescLang(item.MilestoneDesc) }}
            </div>
            <div>
              <img v-if="item.MilestoneDesc === '已签收'" src="@/assets/tms/sign.png" />
              <img v-if="item.MilestoneDesc === '运输中' && index === 0" src="@/assets/tms/transport_check.png" />
              <img v-else-if="item.MilestoneDesc === '运输中'" src="@/assets/tms/transport.png" />
              <img v-if="item.MilestoneDesc === '已提货' && index === 0" src="@/assets/tms/collect_check.png" />
              <img v-else-if="item.MilestoneDesc === '已提货'" src="@/assets/tms/collect.png" />
              <!-- <div
                class="circular-ring"
                :style="{
                  border:
                    index === 0 ? '2px solid #59B9D3' : '2px solid #CCD1DA',
                }"
              ></div> -->
              <div
                class="line-between"
                :style="{ display: index == listData.length - 1 ? 'none' : '' }"
              ></div>
            </div>
            <div style="margin-top: 6px;margin-left: 4vw;">
              <div class="node-times" :style="{ color: index === 0 ? '#59B9D3' : '#4B5563' }">{{ item.EventDT }}</div>
            </div>
            <div
              class="node-description"
              :style="{ color: index === 0 ? '#59B9D3' : '#4B5563' }"
            >
               {{ item.Address }}
            </div>
          </div>
        </div>
        <div v-else class="no-data">
          <img src="@/assets/tms/no_data.png" />
          <div class="no-data-text">{{ $t('DomesticTransportation.notLogisticsSchedule') }}</div>
        </div>
      </div>
      <el-dialog
        custom-class="receipt-dialog"
        :title="$t('DomesticTransportation.ViewReceiptProof')"
        :visible.sync="receiptVisible"
        width="30%"
      >
        <div v-for="file in receiptList" :key="file" class="receipt-img">
          <div v-if="pictureTypeOptions.includes(judgeType(file))">
            <img style="width:100%;height:100%;object-fit: contain;" :src="file" />
            <div class="opeartor">
              <el-button
                type="primary"
                size="small"
                style="display: block; width: 100%"
                @click="preview(file)"
              >
              {{ $t('DomesticTransportation.view') }}
              </el-button>
              <el-button
                type="primary"
                size="small"
                style="margin-left: 0px; width: 100%; margin-top: 8px"
                @click="downloadIamge(file,'回单')"
              >
              {{ $t('DomesticTransportation.download') }}
              </el-button>
            </div>
          </div>
          <div v-else style="margin-top: 32px;">
            <img style="width:64px;height:64px;margin-bottom: 8px;" src="@/assets/tms/unknown_file.png" />
            <div>{{ $t('DomesticTransportation.dontPreview') }}</div>
            <div><a @click="downloadIamge(file,'回单文件')">{{ $t('DomesticTransportation.download') }}</a></div>
          </div>
        </div>
      </el-dialog>
      <div style="display:none">
        <viewer :images="viewerUrl" @inited="inited" class="viewer" ref="viewer">
          <template #default="scope">
            <img :src="viewerUrl[0]" />
            {{ scope }}
          </template>
        </viewer>
      </div>
    </div>
  </div>
</template>
<script>
import AMapLoader from '@amap/amap-jsapi-loader'
import { getordertaskmilestonelist, getreceiptlist, downloadFile } from '@/api/tms'
import Language from '@/components/Language/index.vue'

import i18n from '@/i18n/i18n'
export default {
  components: { Language },
  name: 'MapTrack',
  data() {
    return {
      listData: [],
      map: {},
      loadAddress: '',
      unloadAddress: '',
      receiptDis: false,
      receiptVisible: false,
      viewerUrl: [],
      receiptList: [],
      pictureTypeOptions: ['jpg', 'png', 'jpeg', 'gif'],
      OrderID: '',
      addressInfo: {},
      OrderData: {},
      TaskContainerStatus: '',
      driving: null,
      TaskID: '',
      JobType: '',
      urlQuery: {},
      lang: 'zh'
    }
  },
  mounted() {
    // this.TaskContainerID = this.$route.query.TaskContainerID || ''
    this.lang = this.$ls.get('lang')
    this.TaskID = this.$route.query.jobID || ''
    this.JobType = this.$route.query.JobType || ''
    this.urlQuery = this.$route.query
    this.init(
    //   this.TaskContainerID,
      this.TaskID
    )
  },
  methods: {
    handleClose() {
      this.$emit('close')
    },
    openReceipt() {
      const params = {
        TaskID: this.TaskID,
        // TaskContainerID: this.TaskContainerID,
        OrderID: this.OrderID
      }
      getreceiptlist(Object.assign(this.urlQuery, params)).then(res => {
        this.receiptList = res.Data || []
        if (res.Data && res.Data.length) {
          this.receiptVisible = true
        } else {
          this.$message({
            message: '暂无回单记录',
            type: 'warning'
          })
        }
      })
    },
    init(
    //   TaskContainerID,
      TaskID
    ) {
      if (!TaskID) return
      getordertaskmilestonelist(this.urlQuery).then((res) => {
        if (!res.Data) return
        this.listData = res.Data.Data || []
        this.OrderData = res.Data.OrderData || {}
        if (!this.OrderData) return
        this.OrderID = this.OrderData.OrderID
        this.TaskContainerStatus = this.OrderData.TaskContainerStatus
        this.loadAddress = this.OrderData.LoadingAddress
        this.unloadAddress = this.OrderData.UnLoadingAddress
        this.receiptDis = this.OrderData.EPODCount === 0
        this.addressInfo = {
          TaskContainerID: this.OrderData.TaskContainerID,
          PickCity: this.OrderData.LoadingLocCityLongName,
          PickArea: this.OrderData.LoadingLocDistrictLongName,
          PickContact: this.OrderData.LoadingContact,
          LoadingLocaName: this.OrderData.LoadingLocaName,
          DropCity: this.OrderData.UnLoadingLocCityLongName,
          DropArea: this.OrderData.UnLoadingLocDistrictLongName,
          DropContact: this.OrderData.UnLoadingContact,
          UnLoadingLocaName: this.OrderData.UnLoadingLocaName
        }
        const LoadLngLat = this.OrderData.LoadingLngLat
        const UnLoadLngLat = this.OrderData.UnLoadingLngLat
        this.initMap(LoadLngLat.split(','), UnLoadLngLat.split(','))
      })
    },
    goBackList() {
      window.opener = null
      window.open('', '_self')
      window.close()
    },
    initMap(loadLngLat, unloadLngLat) {
      AMapLoader.load({
        key: '61ba8ec814dab5090d0528f1e8a9c5a5', // 申请好的Web端开发者Key，首次调用 load 时必填
        version: '2.0', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: ['AMap.ToolBar', 'AMap.Driving'] // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      })
        .then((AMap) => {
          this.map = new AMap.Map('container', {
            // 设置地图容器id
            // zoom: zoom // 初始化地图级别
          })
          var startIcon = new AMap.Icon({
            size: new AMap.Size(25, 34),
            image: require('@/assets/tms/start_icon.png'),
            imageSize: new AMap.Size(28, 28)
          })
          var endIcon = new AMap.Icon({
            size: new AMap.Size(25, 34),
            image: require('@/assets/tms/end_icon.png'),
            imageSize: new AMap.Size(28, 28)
          })
          var startMarker = new AMap.Marker({
            position: loadLngLat,
            icon: startIcon,
            autoRotation: true,
            offset: new AMap.Pixel(-14, -28)
          })
          startMarker.setLabel({
            direction: 'top',
            offset: new AMap.Pixel(0, -6), // 设置文本标注偏移量
            content: '装货点：' + this.verifyAddress(this.addressInfo.LoadingLocaName, this.loadAddress) // 设置文本标注内容
          })
          var endMarker = new AMap.Marker({
            position: unloadLngLat,
            icon: endIcon,
            autoRotation: true,
            offset: new AMap.Pixel(-14, -28)
          })
          endMarker.setLabel({
            direction: 'top',
            offset: new AMap.Pixel(0, -6), // 设置文本标注偏移量
            content: '卸货点：' + this.verifyAddress(this.addressInfo.UnLoadingLocaName, this.unloadAddress) // 设置文本标注内容
          })

          //   map.addControl(new AMap.ToolBar())

          //   coord.reverse()
          this.map.add(endMarker)
          this.map.add(startMarker)
          // 绘制轨迹
          if (this.TaskContainerStatus === '运输中' && this.listData.length && this.listData[0].Longitude && this.listData[0].Latitude) {
            const currentLocation = this.listData[0]
            const cur = [currentLocation.Longitude, currentLocation.Latitude]
            var curIcon = new AMap.Icon({
              size: new AMap.Size(25, 34),
              image: require('@/assets/tms/vehicle_freetime.png'),
              imageSize: new AMap.Size(28, 28)
            })
            var currentMarker = new AMap.Marker({
              position: cur,
              icon: curIcon,
              autoRotation: true,
              offset: new AMap.Pixel(-14, -14),
              angle: this.getAngle(cur, unloadLngLat) - 133
            })
            var currenLabel = new AMap.Marker({
              position: cur,
              icon: null,
              autoRotation: true,
              draggable: true,
              content: '<div class="makerlabel"><img src=""/></div>'
            })
            currenLabel.setLabel({
              direction: 'top',
              offset: new AMap.Pixel(0, -20), // 设置文本标注偏移量
              content: currentLocation.Address + ' - ' + currentLocation.EventDT // 设置文本标注内容
            })

            // var passline = new AMap.Polyline({
            //   path: [loadLngLat, cur],
            //   showDir: false, // 是否显示箭头false/true
            //   strokeColor: '#59b9d3', // 线颜色
            //   strokeOpacity: 1, // 画线透明度
            //   strokeWeight: 3, // 线宽
            //   strokeStyle: 'solid' // 线样式,实线"solid"/虚线"dashed"
            // })
            // var without = new AMap.Polyline({
            //   path: [cur, unloadLngLat],
            //   showDir: false, // 是否显示箭头false/true
            //   strokeColor: '#59b9d3', // 线颜色
            //   strokeOpacity: 1, // 画线透明度
            //   strokeWeight: 3, // 线宽
            //   strokeStyle: 'dashed' // 线样式,实线"solid"/虚线"dashed"
            // })

            this.map.add(currentMarker)
            this.map.add(currenLabel)
            this.drawNavigation(AMap, loadLngLat, cur)
            this.drawNavigation(AMap, cur, unloadLngLat, 'dashed')
            // this.map.add(passline)
            // this.map.add(without)
          } else {
            this.drawNavigation(AMap, loadLngLat, unloadLngLat)
            // var polyline = new AMap.Polyline({
            //   path: [loadLngLat, unloadLngLat],
            //   showDir: false, // 是否显示箭头false/true
            //   strokeColor: '#59b9d3', // 线颜色
            //   strokeOpacity: 1, // 画线透明度
            //   strokeWeight: 3, // 线宽
            //   strokeStyle: 'solid' // 线样式,实线"solid"/虚线"dashed"
            // })
            // this.map.add(polyline)
          }
          this.$nextTick(() => {
            this.map.setFitView()
          })
        })
        .catch((e) => {
          console.log(e)
        })
    },
    drawNavigation(AMap, loadLngLat, unloadLngLat, type) {
      // 构造路线导航类
      if (!this.driving) {
        this.driving = new AMap.Driving({
          policy: AMap.DrivingPolicy.LEAST_TIME
        })
      }
      const _this = this
      // 根据起终点经纬度规划驾车导航路线
      this.driving.search(
        new AMap.LngLat(loadLngLat[0], loadLngLat[1]),
        new AMap.LngLat(unloadLngLat[0], unloadLngLat[1]),
        function (status, result) {
          // result即是对应的驾车导航信息，相关数据结构文档请参考 https://lbs.amap.com/api/javascript-api/reference/route-search#m_DrivingResult
          if (status === 'complete') {
            if (result.routes && result.routes.length) {
              // 绘制第一条路线，也可以按需求绘制其它几条路线
              _this.drawRoute(result.routes[0], AMap, type)
            }
          } else {
          }
        }
      )
    },
    parseRouteToPath(route) {
      var path = []

      for (var i = 0, l = route.steps.length; i < l; i++) {
        var step = route.steps[i]

        for (var j = 0, n = step.path.length; j < n; j++) {
          path.push(step.path[j])
        }
      }

      return path
    },
    drawRoute(route, AMap, type) {
      var path = this.parseRouteToPath(route)
      //   var startMarker = new AMap.Marker({
      //     position: path[0],
      //     map: this.map
      //   })
      //   startMarker.setLabel({
      //     direction: 'top',
      //     offset: new AMap.Pixel(0, -6), // 设置文本标注偏移量
      //     content: '装货点：' + this.loadAddress // 设置文本标注内容
      //   })
      //   var endMarker = new AMap.Marker({
      //     position: path[path.length - 1],
      //     map: this.map
      //   })
      //   endMarker.setLabel({
      //     direction: 'top',
      //     offset: new AMap.Pixel(0, -6), // 设置文本标注偏移量
      //     content: '卸货点：' + this.unloadAddress // 设置文本标注内容
      //   })

      var routeLine = new AMap.Polyline({
        path: path,
        isOutline: true,
        showDir: !type,
        strokeColor: '#59b9d3',
        strokeWeight: 4,
        strokeStyle: type || 'solid'
      })

      routeLine.setMap(this.map)

      // 调整视野达到最佳显示区域
      //   this.map.setFitView([routeLine])
    },
    // 根据起始位置判断地图容器缩放等级
    calculateZoom(AMap, start, end) {
      var distance = AMap.GeometryUtil.distance(
        [start[0], start[1]],
        [end[0], end[1]]
      ) // 以高德提供的方法来获取两点间的距离
      var nowDivLine = Math.sqrt(1140 * 1140 + 512 * 512) // 求出地图容器的对角线长度
      var nowScale = distance / nowDivLine // 求出覆盖物范围和地图容器的比例
      var nowNum = 16 - Math.ceil(Math.log(nowScale) / Math.log(2)) // 求出可以显示出所有覆盖物的级别
      return nowNum
    },
    judgeType(file) {
      if (!file) return
      const _index = file.lastIndexOf('.')
      const src = file.slice(_index + 1)
      return src
    },
    downloadIamge(imgsrc, name) { // 下载图片地址和图片名
      if (!imgsrc || imgsrc.indexOf('fileserver') === -1) return
      const url = 'https://cors.mcpsystem.com/' + imgsrc.substring(imgsrc.indexOf('fileserver'))
      downloadFile(url).then((result) => {

      })
    },
    inited(viewer) {
      this.$viewer = viewer
    },
    preview(url) {
      this.viewerUrl = [url]
      this.$viewer.show()
    },
    // 根据两个点计算角度
    getAngle(startLocation, endLocation) {
      const startPoint = {}
      const endPoint = {}
      startPoint.lng = startLocation[0]
      startPoint.lat = startLocation[1]
      endPoint.lng = endLocation[0]
      endPoint.lat = endLocation[1]

      if (!(startPoint && endPoint)) {
        return 0
      }

      let dRotateAngle = Math.atan2(
        Math.abs(startPoint.lng - endPoint.lng),
        Math.abs(startPoint.lat - endPoint.lat)
      )
      if (endPoint.lng >= startPoint.lng) {
        if (endPoint.lat >= startPoint.lat) {
        } else {
          dRotateAngle = Math.PI - dRotateAngle
        }
      } else {
        if (endPoint.lat >= startPoint.lat) {
          dRotateAngle = 2 * Math.PI - dRotateAngle
        } else {
          dRotateAngle = Math.PI + dRotateAngle
        }
      }
      dRotateAngle = (dRotateAngle * 180) / Math.PI
      return dRotateAngle
    },
    // 门店和地址完全一致只显示一个
    verifyAddress(location, address) {
      let add = ''
      if (location === address) {
        add = location
      } else {
        add = location + ' - ' + address
      }
      return add
    },
    // 状态根据当前语言环境处理
    statusDescLang(status){
        let value = ''
        if(this.lang === 'zh'){
            value = status
        }else {
            if(status === '运输中'){
                value = 'In Transit'
            }else if(status === '已提货'){
                value = 'Picked Up'
            }else if(status === '已签收') {
                value = 'Delivered'
            }
        }
        return value
    }
  }
}
</script>
<style lang="less">
.map-track {
  width: 1200px;
  margin: auto;
  background-color: white;
  min-height:100vh;
  padding:20px 30px;
  .el-dialog__headerbtn {
    top: 12px;
    right: 14px;
  }
  .el-dialog__body {
    padding: 20px;
  }
  .map {
    height: 512px;
  }
  .infos {
    font-weight: 800;
    width: 660px;
    padding: 14px 24px;
    border-radius: 16px;
    position: absolute;
    z-index: 99;
    background: #fff;
    left: 50%;
    transform: translateX(-50%);
    top: 70px;
    opacity: 0.8;
    .code {
      margin-bottom: 7px;
      display: flex;
      justify-content: space-between;
    }
    .task-infomation {
        display: flex;
        align-items: center;
        justify-content: space-between;
        text-align: center;
    }
  }
  .color-3 {
    color: #333;
  }
  .color-6 {
    color: #666;
  }
  .color-9 {
    color: #999;
    font-size: 12px;
    margin-top: 8px;
  }
  .arrow {
    width: 88px;
    height: 10px;
    display: block;
  }

  .time-line {
    margin-left: 20px;
    margin-top: 18px;
    .time-line-list {
      margin-top: 14px;
      overflow-y: scroll;
    }
    .no-data {
        text-align: center;
        margin-top: 32px;
        img {
            width: 128px;
            height: 128px;
            display: inline-block;
        }
        .no-data-text {
            margin-top: 16px;
            font-size: 14px;
            color: #666;
        }
    }
    .time-line-item {
      display: flex;
      justify-content: flex-start;
      padding-right: 12px;
      img {
        width:26px;
        height:26px;
      }
      .circular-ring {
        width: 9px;
        height: 9px;
        margin-right: 13px;
        background-color: #ffffff;
        border-radius: 50%;
      }
      .line-between {
        width: 1px;
        background: #ccd1da;
        min-height: 40px;
        height: calc(100% - 26px);
        margin: auto;
      }
      .node-status {
        font-size: 14px;
        font-weight: 500;
        color: #4b5563;
        width: 6vw;
        margin-top: 6px;
        padding-bottom: 32px;
      }
      .node-times {
        font-size: 10px;
        font-weight: 400;
        color: #9ca3af;
      }
      .node-description {
        font-size: 12px;
        margin-top: 2px;
        font-weight: 400;
        color: #4b5563;
        margin-left: 4vw;
        flex:1;
        line-height: 20px;
      }
    }
  }
  .amap-marker-label {
    padding: 6px !important;
    box-shadow: 0 2px 6px 0 #ccc !important;
    border-radius: 4px;
    border: none;
    width: 220px;
    overflow: hidden;
    line-height: 16px;
    white-space: break-spaces;
  }
  .receipt-img {
    border:1px solid #c1c1c1;
    border-radius: 4px;
    margin-bottom: 8px;
    text-align: center;
    position: relative;
    min-height: 180px;
  }
  .receipt-dialog {
    .el-dialog__body {
        height: 70vh;
        overflow-y: scroll;
        padding:10px;
        padding-right: 0;
    }
  }
  .opeartor {
    position: absolute;
    right:8px;
    top:8px;
  }
  ::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 2px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }
  ::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    //background-color: #8c8c8c;
    background-color: rgba(0, 0, 0, 0.25);
  }
  ::-webkit-scrollbar-track {
    background-color: #f6f6f6;
  }
  ::-webkit-scrollbar-thumb,
  ::-webkit-scrollbar-track-piece {
    border: 0;
    background-color: transparent !important;
  }
}
</style>
